<template>
  <div>
    <div class="pb-4 pt-1">
      <el-radio-group v-model="field.is_global_variable">
        <el-radio-button :label="false">Custom Field</el-radio-button>
        <el-radio-button :label="true">Global Variable</el-radio-button>
      </el-radio-group>
    </div>

    <el-form class="" label-position="" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
      <div class="flex items-center justify-center gap-3 w-full">
        <div class="w-1/2">
          <placeholder :field="field" />
        </div>
        <div class="w-1/2">
          <field-filled-by :field="field" />
        </div>
      </div>
      <el-row>
        <div class="flex items-center gap-3 w-full">
          <div class="w-1/2">
            <field-attributes :field="field" />
          </div>
          <div class="">
            <is-field-required :field="field" class="field-required" />
          </div>
        </div>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="icon-dropdown-selection flex items-center !gap-3">
            <span
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Icon
            </span>
            <el-button type="text" @click="iconPickerdialogVisible = true">
              <div class="d-flex align-center menu-icon !gap-2">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus !text-brand-500"></i>
              </div>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-form label-position="right" v-if="field.is_global_variable">
      <el-row>
        <el-col>
          <div class="form-group">
            <el-form-item>
              <div class="flex items-start justify-center gap-3 flex-col !w-full">
                <div>
                  <label>Global Variable</label>
                </div>
                <div class="w-full">
                  <el-select
                    class="!w-full"
                    v-model="field.global_variable_id"
                    @change="setGlobalVariable"
                  >
                    <el-option
                      v-for="(globalVariable, index) of allGlobalVariables"
                      :key="index"
                      :label="globalVariable.label"
                      filterable
                      :value="globalVariable._id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <is-field-required :field="field" class="field-required" />
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  import { fetchGlobalVariables } from '@/repo/globalVariables';
  import { mapGetters } from 'vuex';
  export default {
    name: 'templates-formComponents-SingleLineText',
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      IsFieldRequired: () => import('./IsFieldRequired'),
      FieldFilledBy: () => import('./FieldFilledBy'),
      Placeholder: () => import('./Placeholder'),
      FieldAttributes: () => import('./FieldAttributes.vue'),
    },

    props: ['field'],
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile']),
      allGlobalVariables() {
        return this.getAllGlobalVariables ? this.getAllGlobalVariables.data || [] : [];
      },
    },
    mounted() {
      this.fetchGlobalVaribales();
      if (this.field && this.field.icon_name) {
        this.templateIconPath = this.field.icon_name;
      }
    },
    data() {
      return {
        iconPickerdialogVisible: false,
        templateIconPath: 'dashboard',
        getAllGlobalVariables: null,
      };
    },
    methods: {
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.$set(this.field, 'icon_name', icon);
        this.iconPickerdialogVisible = false;
      },
      async fetchGlobalVaribales() {
        let params = {
          get_all: true,
          input_type: this.field.input_type,
        };
        this.getAllGlobalVariables = await fetchGlobalVariables(params);
      },
      setGlobalVariable() {
        let globalVariable = this.allGlobalVariables.find(
          (x) => x._id == this.field.global_variable_id
        );
        this.field.label = globalVariable.label;
        this.field.description = globalVariable.description;
        this.field.options = globalVariable.options;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-dropdown-selection {
    margin-right: 0.75em;

    i {
      font-size: 1.5em;
    }
  }
</style>
